/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, useState, useEffect, useCallback } from "react";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// My Components:
// import PDFviewer from "../react/PDFviewer.tsx";
import DocViewer from "../react/DocViewer.tsx";

// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getAppState, getDict, getUser } from "../../libs/reducer.ts";
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

const { rz } = window;

type TviwerValue = {
  uri?:string,
  fileName?:string,
  fileType?:string,
  allowEditOfficeFiles?:boolean
}

const stlBgImgError:{[key:string]:string} = {
  backgroundImage: "url('/img/app/bg/page-not-found.png')",
  backgroundColor: "rgba(70,70,70,100)", backgroundBlendMode: "multiply", OBackgroundSize: "cover", MozBackgroundSize: "cover", WebkitBackgroundSize: "cover", backgroundPosition: "center center"
};

const RZDocviewer:FC<TuniversalElementProps> = ({attributes}) => {
  RZDocviewer.displayName = "Docviewer";
  const user = useAppSelector(getUser);
  const dct = useAppSelector(getDict);

  const {rootAttributes, key, fullPath, align} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const appState = useAppSelector(getAppState(rootAttributes.key)), elState = appState[fullPath];
  // const rootNamespace = useMemo(() => (window[rootAttributes?.key || rz.strMakeID(24)]), [rootAttributes?.key]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    // if (!rz.arrContains(userClss, (/-theme-/igm))) { userClss.push("rz-theme-d5") }
    return userClss;
  }, [elState?.userClass, elState?.disabled, permissions]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    return est;
  }, [elState.userStyle, elState?.visible, permissions]);

  // fileList
  const [fileObject, setFileObject] = useState<TviwerValue>({});

  // new version of the extensibleFileList
  useEffect(() => {
    const filObj:TviwerValue = {};
    if (elState?.value) {
      if (rz.isObject(elState.value) && (elState.value.uri || elState.value.url)) {
        filObj.uri = (elState.value.uri || elState.value.url)
        if (elState.value.fileName) { filObj.fileName = elState.value.fileName; filObj.fileType = rz.strFileExtension(elState.value.fileName) }
        else if (elState.value.name) { filObj.fileName = elState.value.name; filObj.fileType = rz.strFileExtension(elState.value.name) }
        else {
          const fnm = (rz.strFileName(elState.value.uri || elState.value.url)).split("?")[0]; if (fnm) { filObj.fileName = fnm; filObj.fileType = rz.strFileExtension(fnm) }
        }

        if (elState.value.allowEditOfficeFiles) { filObj.allowEditOfficeFiles = true }
      }
      else if (rz.isString(elState.value)) {
        filObj.uri = elState.value;
        const fnm = (rz.strFileName(elState.value)).split("?")[0]; if (fnm) { filObj.fileName = fnm; filObj.fileType = rz.strFileExtension(fnm) }
      }
    }
    setFileObject(filObj);
  }, [elState.value]);

  // useEffect(() => { console.log({state_value: elState.value, fileObject}) }, [elState.value, fileObject]);

  return (
    // Применяем вычисленные class/style wrapper-а, чтобы visible/disabled/userStyle работали для docviewer.
    <div key={"docviwer-wrapper-" + key} className={clsu.join(" ")} style={{height: "100%", ...styl}}>{
      (fileObject && fileObject.uri)
        ? (<DocViewer viewerKey={key} className="rz-width-1-1 rz-theme-d3" style={{height: "100%"}} document={fileObject} />)
        : (
          <div className="uk-flex uk-flex-center uk-flex-middle" style={{height: "100%"}}>
            <h2 className="uk-margin-remove uk-text-center txt-white txt-stroke-red-shadow">{dct.e.fileNotFound}</h2>
          </div>
        )
    }</div>
  );
}

export default RZDocviewer;
/* eslint-enable @typescript-eslint/no-unused-vars */
